import React from 'react';
import { styled } from '@mui/system';
import { Box, Typography } from '@fedsim/components';
import { BORDERRADIUS as borderRadius } from '@fedsim/constants'

const fontFamily = 'system-ui'

interface HealthBarProps {
    label: string;
    value: number;
    color: string;
    backgroundColor?: string;
}

interface HealthBarFillProps {
    value?: number;
    color?: string;
    backgroundColor?: string;
}

const getHealthBarColor = (value: number) => {
    if (value > 65) {
        return '#28c324';
    } else if (value > 30) {
        return '#daa733';
    } else if (value > 10) {
        return '#f3da2c';
    } else {
        return '#a11a12';
    }
};

const HealthBarContainer = styled(Box)(() => ({
    position: 'relative',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    border: '1px solid #000',
    height: 15,
    borderRadius,
    overflow: 'hidden'
}));

const HealthBarFill = styled('div')<HealthBarFillProps>(({ value, color, backgroundColor }) => {
    const baseColor = getHealthBarColor(value);
    // const gradient = `linear-gradient(90deg, ${baseColor} 15%,  ${baseColor} 95%)`;
    // const keyframes = {
    //     '@keyframes rollingGradient': {
    //         '0%': {
    //             backgroundPosition: '0% 50%',
    //         },
    //         '50%': {
    //             backgroundPosition: '100% 50%',
    //         },
    //         '100%': {
    //             backgroundPosition: '0% 50%',
    //         },
    //     }
    // }
    return {
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        width: `${value}%`,
        backgroundImage: baseColor,
        backgroundColor: baseColor,
        backgroundSize: '200% 100%',
        color,
        // backgroundImage: `linear-gradient(90deg, ${color} 25%, ${backgroundColor} 50%, ${color} 75%)`,
        // backgroundSize: '400% 100%',
    }
});


const HealthBarLabel = styled(Typography)<HealthBarFillProps>(() => {
    return {
        position: 'absolute',
        left: '0%',
        backgroundColor: 'rgba(0,0,0,0.6)',
        fontSize: 9,
        fontFamily,
        color: 'white',
        paddingX: '8px',
    }
});

const HealthBar: React.FC<HealthBarProps> = (props) => {
    return (
        <HealthBarContainer>
            <HealthBarFill value={props.value} color={props?.color} backgroundColor={props?.backgroundColor} />
            <HealthBarLabel color={props?.color}><>{props.label} {props?.value}%</></HealthBarLabel>
        </HealthBarContainer>
    );
};

export default HealthBar;
